import { SeriesPickerModal } from "../common/SeriesPickerModal.js";
import { AdminMarketingService, CAMPAIGN_CATEGORIES, getDefaultPostContent } from "../../services/admin-marketing.service.js";

export class CampaignCreationModal {
    constructor(onSuccess) {
        this.onSuccess = onSuccess;
        this.overlay = null;
        this.seriesData = null; // { id, title }
    }

    render() {
        // Remove existing
        const existing = document.getElementById('campaign-modal');
        if (existing) existing.remove();

        // Build category options
        const categoryOptions = Object.entries(CAMPAIGN_CATEGORIES).map(([key, cfg]) =>
            `<option value="${key}" data-needs-series="${cfg.needsSeries}">${cfg.label} (${key})</option>`
        ).join('');

        // Overlay
        this.overlay = document.createElement('div');
        this.overlay.id = 'campaign-modal';
        this.overlay.className = 'fixed inset-0 bg-black/60 z-[9999] flex items-center justify-center animate-fade-in backdrop-blur-sm p-4';

        this.overlay.innerHTML = `
            <div class="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden transform transition-all scale-95 opacity-0 flex flex-col max-h-[90vh]" id="campaign-content">
                
                <!-- Header -->
                <div class="px-6 py-5 border-b border-gray-100 bg-gradient-to-r from-gray-50 to-white flex justify-between items-center">
                    <h3 class="text-xl font-bold text-gray-900 flex items-center gap-2">
                        <span class="material-symbols-outlined text-amber-500">campaign</span>
                        캠페인 이벤트 생성
                    </h3>
                    <button id="btn-campaign-close" class="text-gray-400 hover:text-gray-600 transition-colors p-1 rounded-full hover:bg-gray-100">
                        <span class="material-symbols-outlined">close</span>
                    </button>
                </div>

                <!-- Body (Scrollable) -->
                <div class="p-6 overflow-y-auto space-y-5">
                    
                    <!-- Title -->
                    <div>
                        <label class="block text-xs font-bold text-gray-500 uppercase mb-1">캠페인 제목</label>
                        <input type="text" id="input-title" class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500 transition-all" placeholder="예: 주말 정주행 이벤트">
                    </div>

                    <!-- Campaign Category -->
                    <div>
                        <label class="block text-xs font-bold text-gray-500 uppercase mb-1">캠페인 카테고리</label>
                        <select id="input-category" class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500 transition-all appearance-none cursor-pointer">
                            ${categoryOptions}
                        </select>
                    </div>

                    <!-- Benefit Type -->
                    <div>
                        <label class="block text-xs font-bold text-gray-500 uppercase mb-1">혜택 배율 (Multiplier)</label>
                        <select id="input-variant" class="w-full bg-gray-50 border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500 transition-all appearance-none cursor-pointer">
                            <option value="weekend">Weekend (2x)</option>
                            <option value="flash">Flash (3x)</option>
                            <option value="mega">Mega (5x)</option>
                        </select>
                    </div>

                    <!-- Date Selection -->
                    <div class="grid grid-cols-2 gap-4">
                        <div>
                            <label class="block text-xs font-bold text-gray-500 uppercase mb-1">시작 일시</label>
                            <input type="text" id="input-start" class="w-full bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500 transition-all" placeholder="시작일 선택...">
                        </div>
                        <div>
                            <label class="block text-xs font-bold text-gray-500 uppercase mb-1">종료 일시</label>
                            <input type="text" id="input-end" class="w-full bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-amber-500 transition-all" placeholder="종료일 선택...">
                        </div>
                    </div>
                    
                    <!-- Date Validation Feedback -->
                    <div id="date-feedback" class="text-xs font-medium hidden flex items-center gap-1.5 px-3 py-2 rounded-lg">
                        <!-- Dynamic Content -->
                    </div>

                    <!-- Target Series (only for reading_reward) -->
                    <div id="series-section">
                        <label class="block text-xs font-bold text-gray-500 uppercase mb-1">대상 작품 <span class="text-gray-400">(감상 보상 전용)</span></label>
                        <div class="flex gap-2">
                            <div class="relative flex-grow">
                                <input id="display-series" type="text" readonly class="w-full bg-gray-100 border border-transparent text-gray-500 rounded-lg pl-3 pr-10 py-2.5 text-sm cursor-not-allowed select-none" placeholder="작품을 선택해주세요">
                                <span class="material-symbols-outlined absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm">lock</span>
                            </div>
                            <button type="button" id="btn-pick" class="bg-indigo-50 text-indigo-600 border border-indigo-100 hover:bg-indigo-100 hover:border-indigo-200 px-4 rounded-lg font-bold text-sm transition-all whitespace-nowrap shadow-sm flex items-center gap-1">
                                <span class="material-symbols-outlined text-lg">search</span> 선택
                            </button>
                        </div>
                    </div>

                    <!-- Plaza Auto-Post -->
                    <div class="bg-blue-50 border border-blue-100 rounded-xl p-4">
                        <label class="flex items-center gap-2 text-sm font-bold text-blue-700 mb-2 cursor-pointer">
                            <input type="checkbox" id="input-auto-post" class="rounded" checked>
                            <span class="material-symbols-outlined text-lg">forum</span>
                            썰화 클럽 자동 포스팅
                        </label>
                        <textarea id="input-post-message" class="w-full bg-white border border-blue-200 rounded-lg px-3 py-2 text-sm text-gray-700 resize-none focus:outline-none focus:ring-2 focus:ring-blue-400" rows="3" placeholder="기본 메시지가 자동 생성됩니다..."></textarea>
                        <p class="text-[10px] text-blue-400 mt-1">편집하지 않으면 기본 문구가 사용됩니다. (10개국어 자동 적용)</p>
                    </div>

                </div>

                <!-- Footer -->
                <div class="p-4 border-t border-gray-100 bg-gray-50 flex justify-end gap-3">
                    <button id="btn-cancel" class="px-5 py-2.5 bg-white border border-gray-200 text-gray-600 rounded-xl font-bold text-sm hover:bg-gray-100 transition-colors">
                        취소
                    </button>
                    <button id="btn-create" class="px-5 py-2.5 bg-amber-500 text-white rounded-xl font-bold text-sm hover:bg-amber-600 transition-all shadow-md flex items-center gap-2 transform active:scale-95">
                        <span class="material-symbols-outlined text-lg">add_circle</span>
                        이벤트 생성
                    </button>
                </div>
            </div>
        `;

        document.body.appendChild(this.overlay);

        // Animation In
        requestAnimationFrame(() => {
            const content = this.overlay.querySelector('#campaign-content');
            content.classList.remove('scale-95', 'opacity-0');
            content.classList.add('scale-100', 'opacity-100');
        });

        this.bindEvents();
    }

    bindEvents() {
        const closeBtn = this.overlay.querySelector('#btn-campaign-close');
        const cancelBtn = this.overlay.querySelector('#btn-cancel');
        const pickBtn = this.overlay.querySelector('#btn-pick');
        const createBtn = this.overlay.querySelector('#btn-create');
        const categorySelect = this.overlay.querySelector('#input-category');
        const variantSelect = this.overlay.querySelector('#input-variant');
        const titleInput = this.overlay.querySelector('#input-title');
        const postMessageArea = this.overlay.querySelector('#input-post-message');
        const seriesSection = this.overlay.querySelector('#series-section');
        const startInput = this.overlay.querySelector('#input-start');
        const endInput = this.overlay.querySelector('#input-end');

        // Initialize Flatpickr with Confirm Button
        const baseConfig = {
            enableTime: true,
            dateFormat: "Y-m-d H:i",
            time_24hr: true,
            disableMobile: "true",
            plugins: [new confirmDatePlugin({
                confirmIcon: "<i class='material-symbols-outlined ml-2'>check</i>",
                confirmText: "확인 (Confirm)",
                showAlways: true,
                theme: "light"
            })],
            onChange: () => validateDates()
        };

        const fpStart = flatpickr(startInput, { ...baseConfig, minDate: "today" });
        const fpEnd = flatpickr(endInput, { ...baseConfig, minDate: "today" });

        // Category Change → Show/Hide series, update default message
        const updateCategoryUI = () => {
            const cat = categorySelect.value;
            const needsSeries = CAMPAIGN_CATEGORIES[cat]?.needsSeries;
            seriesSection.style.display = needsSeries ? 'block' : 'none';

            // Update default post message preview
            const multiplierMap = { 'weekend': 2, 'flash': 3, 'mega': 5 };
            const previewData = {
                title: titleInput.value || '캠페인 제목',
                boostCategory: cat,
                multiplier: multiplierMap[variantSelect.value] || 2,
                seriesTitle: this.seriesData?.title || '작품명'
            };
            postMessageArea.placeholder = getDefaultPostContent(previewData, 'ko');
        };

        categorySelect.onchange = updateCategoryUI;
        variantSelect.onchange = updateCategoryUI;
        titleInput.oninput = updateCategoryUI;
        updateCategoryUI(); // Initial state

        // Close logic
        const close = () => {
            const content = this.overlay.querySelector('#campaign-content');
            content.classList.remove('scale-100', 'opacity-100');
            content.classList.add('scale-95', 'opacity-0');
            setTimeout(() => {
                fpStart.destroy();
                fpEnd.destroy();
                this.overlay.remove();
                this.overlay = null;
            }, 200);
        };

        closeBtn.onclick = close;
        cancelBtn.onclick = close;
        this.overlay.onclick = (e) => {
            if (e.target === this.overlay) close();
        };

        // Pick Series
        pickBtn.onclick = () => {
            new SeriesPickerModal((selected) => {
                this.seriesData = selected;
                document.getElementById('display-series').value = selected.title;
                document.getElementById('display-series').classList.add('text-gray-900', 'font-medium', 'bg-white', 'border-gray-200');
                document.getElementById('display-series').classList.remove('text-gray-500', 'bg-gray-100', 'border-transparent');
                updateCategoryUI(); // Refresh post preview
            }).render();
        };

        // Date Validation Logic
        const validateDates = () => {
            const startVal = startInput.value;
            const endVal = endInput.value;
            const feedback = document.getElementById('date-feedback');

            if (!startVal || !endVal) {
                feedback.className = "hidden";
                return false;
            }

            const start = new Date(startVal);
            const end = new Date(endVal);

            if (start >= end) {
                feedback.className = "text-xs font-bold flex items-center gap-1.5 px-3 py-2 rounded-lg bg-red-50 text-red-600 border border-red-100 animate-pulse";
                feedback.innerHTML = `<span class="material-symbols-outlined text-sm">error</span> 종료일은 시작일보다 미래여야 합니다.`;
                createBtn.disabled = true;
                createBtn.classList.add('opacity-50', 'cursor-not-allowed');
                return false;
            } else {
                const diffMs = end - start;
                const diffHrs = (diffMs / (1000 * 60 * 60)).toFixed(1);
                const diffDays = (diffHrs / 24).toFixed(1);
                let durationText = `${diffHrs}시간`;
                if (diffHrs > 48) durationText = `${diffDays}일`;

                feedback.className = "text-xs font-bold flex items-center gap-1.5 px-3 py-2 rounded-lg bg-green-50 text-green-600 border border-green-100";
                feedback.innerHTML = `<span class="material-symbols-outlined text-sm">check_circle</span> 기간 설정 완료 (${durationText})`;

                createBtn.disabled = false;
                createBtn.classList.remove('opacity-50', 'cursor-not-allowed');
                return true;
            }
        };

        // CREATE Action
        createBtn.onclick = async () => {
            // Clear previous errors
            const inputs = ['input-title', 'display-series', 'input-start', 'input-end'];
            inputs.forEach(id => {
                const el = document.getElementById(id);
                if (el) el.classList.remove('border-red-500', 'ring-2', 'ring-red-200', 'bg-red-50');
            });

            const title = titleInput.value.trim();
            const category = categorySelect.value;
            const variant = variantSelect.value;
            const start = startInput.value;
            const end = endInput.value;
            const autoPost = document.getElementById('input-auto-post')?.checked ?? true;
            const customMessage = postMessageArea.value.trim();
            const needsSeries = CAMPAIGN_CATEGORIES[category]?.needsSeries;

            let hasError = false;

            // Validate Title
            if (!title) {
                titleInput.classList.remove('border-gray-200');
                titleInput.classList.add('border-red-500', 'ring-2', 'ring-red-200', 'bg-red-50');
                titleInput.focus();
                titleInput.classList.add('animate-pulse');
                setTimeout(() => titleInput.classList.remove('animate-pulse'), 500);
                hasError = true;
            }

            // Validate Series (only for reading_reward)
            else if (needsSeries && !this.seriesData) {
                const seriesInput = document.getElementById('display-series');
                seriesInput.classList.remove('border-transparent', 'bg-gray-100');
                seriesInput.classList.add('border-red-500', 'ring-2', 'ring-red-200', 'bg-red-50');
                seriesInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
                hasError = true;
            }

            // Validate Date (Start)
            else if (!start) {
                startInput.classList.remove('border-gray-200');
                startInput.classList.add('border-red-500', 'ring-2', 'ring-red-200', 'bg-red-50');
                hasError = true;
            }

            // Validate Date (End)
            else if (!end) {
                endInput.classList.remove('border-gray-200');
                endInput.classList.add('border-red-500', 'ring-2', 'ring-red-200', 'bg-red-50');
                hasError = true;
            }

            if (hasError) return;

            if (!validateDates()) return;

            // Prepare Data
            const multiplierMap = { 'weekend': 2, 'flash': 3, 'mega': 5 };
            const eventData = {
                title,
                startDate: start,
                endDate: end,
                type: 'CAMPAIGN',
                boostCategory: category,
                variant,
                multiplier: multiplierMap[variant] || 2,
                autoPost,
                customPostMessage: customMessage || null,
                // Series fields (only for reading_reward)
                ...(needsSeries && this.seriesData ? {
                    seriesId: this.seriesData.id,
                    seriesTitle: this.seriesData.title
                } : {})
            };

            // Loading State
            createBtn.disabled = true;
            createBtn.innerHTML = '<span class="loader-spin w-5 h-5 border-2 border-white/30 border-t-white rounded-full"></span>';

            try {
                await AdminMarketingService.createEvent(eventData);
                close();
                if (this.onSuccess) this.onSuccess();
                await window.Modal.alert("이벤트가 성공적으로 생성되었습니다!");
            } catch (e) {
                console.error(e);
                window.Modal.alert(`생성 실패: ${e.message}`);
                createBtn.disabled = false;
                createBtn.innerHTML = '<span class="material-symbols-outlined text-lg">add_circle</span> 이벤트 생성';
            }
        };
    }
}
